"use client";

import Link from "@/infrastructure/router/Link";
import type { CSSProperties } from "react";
import {
	ArtistIcon,
	GlassIconButton,
} from "@/components/design-system/ArtistDesignSystem";

export interface LibraryTopBarProps {
	readonly showCreatePlaylist: boolean;
	readonly onOpenCreatePlaylist: () => void;
}

const barStyle: CSSProperties = {
	position: "absolute",
	top: "calc(env(safe-area-inset-top, 0px) + 12px)",
	right: 16,
	zIndex: 4,
	display: "flex",
	gap: 8,
	alignItems: "center",
};

/**
 * LibraryTopBar — floating toolbar that overlays the hero's top-right corner.
 * Mirrors the SwiftUI `toolbar` on iOS LibraryView: settings gear (always)
 * + plus button (only when the 收藏 tab is selected). Uses the on-media
 * glass icon button variant so the controls stay legible over the hero.
 */
export function LibraryTopBar({
	showCreatePlaylist,
	onOpenCreatePlaylist,
}: Readonly<LibraryTopBarProps>) {
	return (
		<div className="library-top-bar" style={barStyle}>
			<Link
				href="/settings"
				aria-label="设置"
				className="ds-icon-button library-top-bar__button"
				style={{
					color: "var(--ds-on-media-primary)",
					background: "rgb(0 0 0 / 0.42)",
					borderColor:
						"color-mix(in srgb, var(--ds-on-media-primary) 30%, transparent)",
				}}
			>
				<ArtistIcon name="settings" size={19} strokeWidth={1.8} />
			</Link>
			{showCreatePlaylist ? (
				<GlassIconButton
					label="新建歌单"
					onMedia
					onClick={onOpenCreatePlaylist}
				>
					<ArtistIcon name="plus" size={20} strokeWidth={2.2} />
				</GlassIconButton>
			) : null}
		</div>
	);
}
